import React from 'react';
import { ModuleFeatureContext } from '~/templates/blocks/context/ModuleFeatureContext';
import { M132ProductSetDetailModule } from '~/lib/data-contract';
import ProductSetDetailDataWrapper from './product-set-details/product-set-details-data-wrapper';

const M132ProductSetDetails = (props: M132ProductSetDetailModule) => {
    return (
        <ModuleFeatureContext.Provider value={{ reserveInStore: false }}>
            <ProductSetDetailDataWrapper {...props} />
        </ModuleFeatureContext.Provider>
    );
};

export default M132ProductSetDetails;
